import { createSlice } from '@reduxjs/toolkit';
import { actions } from '.';
import { File } from '@law-connect/types';

interface LawyerConnectionState {
  pending: {
    fetch?: boolean;
    send?: boolean;
  };
  errors: {
    fetch?: string | null;
    send?: string | null;
  };
  connections: {
    // we have this structure so when updating the connection we dont overwrite the messages
    [id: string]: {
      chat: File[];
      prematter: File[];
    };
  };
}

const fileState: LawyerConnectionState = {
  pending: {},
  errors: {},
  connections: {},
};

const fileSlice = createSlice({
  name: 'file',
  initialState: fileState,
  // you cant have a reducer name match the thunk action
  reducers: {},
  extraReducers: (builder) => {
    // fetch single connection by id
    builder.addCase(actions.file.fetch.pending, (state) => {
      state.errors.fetch = null;
      state.pending.fetch = true;
    });
    builder.addCase(actions.file.fetch.fulfilled, (state, action) => {
      state.errors.fetch = null;
      state.pending.fetch = false;
      if (action.payload) {
        state.connections[action.meta.arg.connectionId] = action.payload;
      }
    });
    builder.addCase(actions.file.fetch.rejected, (state, action) => {
      state.errors.fetch = action.error.message;
      state.pending.fetch = false;
    });
    // send file
    builder.addCase(actions.file.sendFiles.pending, (state) => {
      state.pending.send = true;
      state.errors.send = null;
    });
    builder.addCase(
      actions.file.sendFiles.fulfilled,
      (state, action) => {
        state.pending.send = false;
        state.errors.send = null;
      }
    );
    builder.addCase(actions.file.sendFiles.rejected, (state, action) => {
      state.pending.send = false;
      state.errors.send = action.error.message;
    });
  },
});

// im not sure if this is good practice but it mimics what we used to do with dispatching actions
export const fileActions = fileSlice.actions;
export const fileReducer = fileSlice.reducer;
